import React, { Fragment } from 'react';

import Can from '../Can';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/dateUtils';

export const AnalysisCard = ({ analysis }) => (
    <Can I="read" a="Analysis">
        {analysis ? (
            <Fragment>
                <dl>
                    <dt>Analysis Status</dt>
                    <dd>
                        {analysis.status}{' '}
                        <Link to={`/analysis-viewer/${analysis.id}`}>
                            <button type="button" className="btn btn-link">
                                {window.location.pathname.includes('analysis-viewer')
                                    ? ''
                                    : 'Audit'}
                            </button>
                        </Link>
                    </dd>
                    <dt>Marked Ready for Analysis at</dt>
                    <dd>
                        {analysis.started
                            ? formatDate(analysis.started)
                            : formatDate(analysis.created)}
                    </dd>
                    <dt>Last Updated at</dt>
                    <dd>{analysis.updated ? formatDate(analysis.updated) : 'N/A'}</dd>
                </dl>
            </Fragment>
        ) : (
            ''
        )}
    </Can>
);

AnalysisCard.propTypes = {
    analysis: PropTypes.object,
};
